import { useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { Link, useNavigate } from "react-router-dom";
// @mui
import { alpha } from "@mui/material/styles";
import {
  Box,
  Divider,
  Typography,
  Stack,
  MenuItem,
  Avatar,
  IconButton,
  Popover,
  ListItemIcon,
} from "@mui/material";
import { logOut } from "../../../features/auth/authSlice";
import { useSendLogoutMutation } from "../../../features/auth/authApiSlice";
import Iconify from "../../../components/iconify/Iconify";
import {
  selectCurrentUser,
  selectCurrentUserData,
} from "../../../features/auth/authSlice";
import { serverURL } from "../../../app/api/axios/http.service";

// auth
// ----------------------------------------------------------------------

const MENU_OPTIONS = [
  {
    label: "Startseite",
    icon: "eva:home-fill",
    path: "/dashboard/app",
  },
  {
    label: "Profil",
    icon: "eva:person-fill",
    path: "/dashboard/profil",
    // role: SYSTEM_ROLES.user,
  },
  {
    label: "Support",
    icon: "ic:twotone-help",
    path: "/dashboard/support",
  },
  {
    label: "Einstellungen",
    icon: "eva:settings-2-fill",
    path: "/dashboard/settings",
  },
];

// ----------------------------------------------------------------------

export default function AccountPopover() {
  const [open, setOpen] = useState(null);
  const [sendLogout] = useSendLogoutMutation();
  const navigate = useNavigate();
  const currentUserData = useSelector(selectCurrentUserData);
  const currentUserMail = useSelector(selectCurrentUser);

  const dispatch = useDispatch();
  const handleOpen = (event) => {
    setOpen(event.currentTarget);
  };

  const handleLogout = () => {
    sendLogout()
      .unwrap()
      .then(() => {
        dispatch(logOut());
        setOpen(null);
        navigate("/login");
      })
      .catch((err) => {
        window.alert(
          "Etwas hat nicht funktioniert.\nBitte versuchen Sie es erneut."
        );
        console.log("err :>> ", err);
      });
  };

  const handleClose = () => {
    setOpen(null);
  };

  const displayName =
    currentUserData?.firstName && currentUserData?.lastName
      ? `${currentUserData.firstName} ${currentUserData.lastName}`
      : currentUserMail || "Benutzerkonto";
  const profileImageUrl =
    currentUserData?.profileImagePath && currentUserData?.id
      ? `${serverURL()}/public/user/image/${currentUserData.id}`
      : "";

  return (
    <>
      <IconButton
        onClick={handleOpen}
        sx={{
          p: 0,
          ...(open && {
            "&:before": {
              zIndex: 1,
              content: "''",
              width: "100%",
              height: "100%",
              borderRadius: "50%",
              position: "absolute",
              bgcolor: (theme) => alpha(theme.palette.grey[900], 0.8),
            },
          }),
        }}
      >
        <Avatar src={profileImageUrl} alt="Profilbild" />
      </IconButton>

      <Popover
        open={Boolean(open)}
        anchorEl={open}
        onClose={handleClose}
        anchorOrigin={{ vertical: "bottom", horizontal: "right" }}
        transformOrigin={{ vertical: "top", horizontal: "right" }}
        PaperProps={{
          sx: {
            p: 0,
            mt: 1.5,
            ml: 0.75,
            width: 260,
            borderRadius: 2,
            overflow: "hidden",
            border: (theme) => `1px solid ${alpha(theme.palette.grey[500], 0.16)}`,
            boxShadow: (theme) =>
              `0 12px 32px ${alpha(theme.palette.grey[900], 0.24)}`,
            "& .MuiMenuItem-root": {
              typography: "body2",
              borderRadius: 0.75,
            },
          },
        }}
      >
        <Box
          sx={{
            px: 2.5,
            py: 2,
            bgcolor: (theme) =>
              alpha(theme.palette.primary.main, 0.08),
            borderBottom: (theme) =>
              `1px dashed ${alpha(theme.palette.grey[500], 0.24)}`,
          }}
        >
          <Stack direction="row" spacing={1.5} alignItems="center">
            <Avatar
              src={profileImageUrl}
              alt="Profilbild"
              sx={{
                width: 48,
                height: 48,
                border: (theme) =>
                  `2px solid ${alpha(theme.palette.primary.main, 0.4)}`,
              }}
            />
            <Box sx={{ minWidth: 0 }}>
              <Typography variant="subtitle2" noWrap>
                {displayName}
              </Typography>
              <Typography
                variant="caption"
                sx={{ color: "text.secondary" }}
                noWrap
              >
                {currentUserMail || "—"}
              </Typography>
            </Box>
          </Stack>
        </Box>

        <Divider sx={{ borderStyle: "dashed" }} />

        <Stack sx={{ p: 1 }}>
          {MENU_OPTIONS.map((option) => (
            <Link
              to={option.path}
              key={option.label}
              style={{ textDecoration: "none" }}
            >
              <MenuItem key={option.label} onClick={handleClose}>
                <ListItemIcon>
                  <Iconify icon={option.icon} width={22} />
                </ListItemIcon>
                {option.label}
              </MenuItem>
            </Link>
          ))}
        </Stack>
        <Divider sx={{ borderStyle: "dashed" }} />

        <MenuItem onClick={handleLogout} sx={{ m: 1 }}>
          <ListItemIcon>
            <Iconify icon="eva:log-out-outline" width={22} />
          </ListItemIcon>
          Abmelden
        </MenuItem>
      </Popover>
    </>
  );
}
